'use client';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { pageGroups } from 'constants/metadata';
import { HOMEPAGE_SEARCH_BAR_BANNER } from '../../../(home)/_constants/constants';
import { MAIN_CAT_HEADER_ID } from '@cat-ecom/pcc-components/src/components/header/constants';

const useSearchBarVisibility = (isSearchBarInHeader) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);

  //this function handles the visibility of top nav search bar based on scroll
  const handleScroll = useCallback(() => {
    const heroSearchHeight = document
      ?.getElementById(HOMEPAGE_SEARCH_BAR_BANNER)
      ?.getBoundingClientRect()?.bottom;
    const topNavHeader = document
      ?.getElementById(MAIN_CAT_HEADER_ID)
      ?.getBoundingClientRect()?.height;
    const isHeroSearchBarBehindHeader = heroSearchHeight - topNavHeader <= 0;
    setIsSearchVisible(isHeroSearchBarBehindHeader);
  }, []);

  const isHomepage = useMemo(() => {
    if (typeof window !== 'undefined') {
      const pageGroupElement: HTMLMetaElement | null = document?.querySelector(
        'meta[name="pageGroup"]'
      );

      return pageGroupElement?.content.toString() === pageGroups.homePage;
    } else {
      return false;
    }
  }, []);

  useEffect(() => {
    if (isHomepage && isSearchBarInHeader) {
      //Its happening before you see anything on the screen because react invokes useEffect's very quickly.so required setTimeout
      setTimeout(() => {
        handleScroll();
      }, 200);
      window.addEventListener('scroll', handleScroll);
    } else {
      setIsSearchVisible(true);
    }
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isSearchBarInHeader, handleScroll, isHomepage]);

  return { isSearchVisible };
};

export default useSearchBarVisibility;
